import { render, staticRenderFns } from "./checkedFormsCard.vue?vue&type=template&id=53860e23&scoped=true&"
import script from "./checkedFormsCard.vue?vue&type=script&lang=js&"
export * from "./checkedFormsCard.vue?vue&type=script&lang=js&"
import style0 from "./checkedFormsCard.vue?vue&type=style&index=0&id=53860e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53860e23",
  null
  
)

export default component.exports